import React from 'react';
import styled from 'styled-components';
import { Controller, FieldPath, FieldValues } from 'react-hook-form';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';
import { InputProps } from './types';
import { ErrorMessage } from '../Services/styled-components';

export interface OrderSelectorEditorProps<TFieldValues extends FieldValues, TName extends FieldPath<TFieldValues>>
  extends InputProps<TFieldValues, TName> {
  label?: string;
  availableNumbers?: number[];
  maxNumber: number;
}

function OrderSelectorEditor<TFieldValues extends FieldValues, TName extends FieldPath<TFieldValues>>({
  control,
  name,
  label,
  availableNumbers,
  maxNumber,
}: OrderSelectorEditorProps<TFieldValues, TName>) {
  const numbersToDisplay = availableNumbers || Array.from({ length: maxNumber }, (_, i) => i + 1);

  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { value, onChange }, fieldState }) => (
        <StyledContainer>
          <FormControl fullWidth error={Boolean(fieldState.error)}>
            <InputLabel>{label || `Display order (1-${maxNumber})`}</InputLabel>
            <Select
              value={value || ''}
              onChange={onChange}
              displayEmpty
            >
              {numbersToDisplay.map((num) => (
                <MenuItem key={num} value={num}>
                  {num}
                </MenuItem>
              ))}
            </Select>
            <ErrorMessage>{fieldState.error?.message}</ErrorMessage>
          </FormControl>
        </StyledContainer>
      )}
    />
  );
}

export const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 30px;
  width: 100%;
`;

export default OrderSelectorEditor; 
